import React from 'react';
import Icon from '../../../../../../muiComponents/Icon';
import useTranslate from '../../../../../../customHooks/useTranslate';
import { useZitoneoSettingsChecks } from '../../../../contexts/ZitoneoContentContext';

interface ImageCheckProps {
    type: 'logo' | 'icon';
}

const IMAGE_CHECKS = {
    logo: { stateKey: 'hasLogo', resource: 'logo' },
    icon: { stateKey: 'hasIcon', resource: 'icon' },
} as const;

const ImageCheck = ({ type }: ImageCheckProps) => {
    const translate = useTranslate();
    const checks = useZitoneoSettingsChecks();
    const { stateKey, resource } = IMAGE_CHECKS[type];
    const complete = checks[stateKey];
    const status = complete ? 'complete' : 'missing';

    return (
        <li className='sidebar__quality_signal__item'>
            <div className='flex-column gap-8'>
                <div className='quality_signal__item__title'>
                    <Icon
                        iconName={
                            complete ? 'Check' : 'ImageNotSupportedOutlined'
                        }
                        className={`quality_signal__item__icon --${
                            complete ? 'success' : 'warning'
                        }`}
                    />
                    <p>{translate(`${resource}__${status}`)}</p>
                </div>
                <p>{translate(`${resource}__${status}_subtitle`)}</p>
            </div>
        </li>
    );
};

export default ImageCheck;
